import { supplyInventory } from '@/api/ay240072z/containerMgt'

export default {
  props: {
    // 是否分值操作
    isScoreSetting: {
      type: Boolean,
      default: false
    },
    deviceCode: {
      type: [String, Number],
      default: undefined
    },
    containerMap: {
      type: Object,
      default: () => {
        return {
          A: [],
          B: [],
          C: [],
          D: []
        }
      }
    }
  },
  watch: {
    containerMap: {
      handler (val) {
        this.handleLayout()
      },
      immediate: true
    }
  },
  data () {
    return {
      spinning: false,
      isEdit: false,
      checkedArr: [],
      checkedIds: [],
      cellLayoutMap: {}
    }
  },
  methods: {
    // 仓格点击事件
    onCellClick (item) {
      if (!this.isScoreSetting) {
        this.supplyInventory({ deviceCode: this.deviceCode, paneCode: item.code, num: 1 })
        return
      }
      if (!this.isEdit) return
      if (!this.checkedIds.includes(item.code)) {
        this.checkedArr.push(item)
      } else {
        this.checkedArr = this.checkedArr.filter(el => el.code !== item.code)
      }
      this.checkedIds = this.checkedArr.map(item => item.code)
      this.$emit('change', this.checkedArr, this.checkedIds)
    },
    // 补货
    supplyInventory (parameter) {
      this.spinning = true
      supplyInventory(parameter)
        .then(res => {
          if (res.code === 200) {
            return this.$message.success('开门成功！请勿遗忘关闭柜门')
          }
          this.$message.warning(res.msg)
        })
        .finally(() => {
          this.spinning = false
        })
    },
    // 仓格快捷操作处理
    quickAction (type, flag) {
      const arr = this.containerMap[type]
      const checkedArr = JSON.parse(JSON.stringify(this.checkedArr))
      if (flag) {
        const list = checkedArr.concat(arr)
        this.checkedArr = [...new Map(list.map(item => [item.code, item])).values()]
      } else {
        this.checkedArr = this.checkedArr.filter(item => item.level !== type)
      }
      this.checkedIds = this.checkedArr.map(item => item.code)
      this.$emit('change', this.checkedArr, this.checkedIds)
    },
    // 开启仓格编辑状态
    open () {
      this.isEdit = true
    },
    // 清除已选中数据
    clear () {
      this.isEdit = false
      this.checkedArr = []
      this.checkedIds = []
      this.$emit('change', this.checkedArr, this.checkedIds)
    },
    // 仓格布局处理
    handleLayout () {
      const map = {}
      for (const key in this.containerMap) {
        const element = this.containerMap[key]
        let chunkSize = 1
        if (this?.config?.[key]) {
          element.forEach(item => {
            item.width = this.config[key].width
            item.height = this.config[key].height
            item.colspan = this.config[key].colspan
          })
          chunkSize = this.config[key].chunkSize
        }
        const result = []
        for (let i = 0; i < element.length; i += chunkSize) {
          result.push(element.slice(i, i + chunkSize))
        }
        map[key] = result
      }
      this.cellLayoutMap = map
    }
  }
}
